import { LastActiveTypeEnum } from 'app/models';

export class LastActiveTypeModel {
    public static LastActiveTypeList: Array<any> = [
        { name: 'All', value: null, dateTime: null },
        { name: 'Online Now', value: LastActiveTypeEnum.OnlineNow, dateTime: null },
        { name: '< 30 mins', value: LastActiveTypeEnum.Under30Min, dateTime: new Date(new Date().getTime() - 30 * 60 * 1000) },
        { name: '< 1 hr', value: LastActiveTypeEnum.Under1Hr, dateTime: new Date(new Date().getTime() - 60 * 60 * 1000) },
        { name: '< 8 hrs', value: LastActiveTypeEnum.Under8Hr, dateTime: new Date(new Date().getTime() - 8 * 60 * 60 * 1000) },
        { name: '< 24 hrs', value: LastActiveTypeEnum.Under24Hr, dateTime: new Date(new Date().getTime() - 24 * 60 * 60 * 1000) },
        { name: '< 72 hrs (3 days)', value: LastActiveTypeEnum.Under72Hr, dateTime: new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000) },
        { name: '< 120 hrs (5 days)', value: LastActiveTypeEnum.Under120Hr, dateTime: new Date(new Date().getTime() - 5 * 24 * 60 * 60 * 1000) },
        { name: '< 168 hrs (7 days)', value: LastActiveTypeEnum.Under168Hr, dateTime: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000) },
        { name: '> 168 hrs', value: LastActiveTypeEnum.More168Hr, dateTime: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000) },
        { name: 'Never', value: LastActiveTypeEnum.Never, dateTime: null }
    ];
}
